import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ScrollToService, ScrollToConfigOptions } from '@nicky-lenaers/ngx-scroll-to';

@Component({
  selector: 'app-index7',
  templateUrl: './index7.component.html',
  styleUrls: ['./index7.component.css'],
  encapsulation: ViewEncapsulation.None,
  styles: [`
    .dark-modal .modal-content {
      background-color: transparent;
      color: white;
      border-radius : 10px;
    }
    .dark-modal .modal-header {
      border : none
    }
    .dark-modal .close {
      color: white;
    }
  `]
})
/**
 * Index-7 component
 */
export class Index7Component implements OnInit {
  id = 'JlvxDa7Sges';

  private player;
  private ytEvent;
  constructor(private modalService: NgbModal, private scrollToService: ScrollToService) {
  }
  currentSection = 'home';

  scrollToElement(id) {
    const config: ScrollToConfigOptions = {
      target: id,
      offset: -100,
      duration: 1000,
      easing: 'easeInOutQuad'
    };

    this.scrollToService.scrollTo(config);
  }

  ngOnInit(): void {

    document.getElementById('color-opt').setAttribute('href', 'assets/css/colors/cyan.css');

    let i = 1;
    setInterval(() => {
      if (i === 1) {
        document.getElementById('slideTitile').innerHTML = 'ALGEBRAIC TECHNOLOGIES LTD';
        document.getElementById('slideBody').innerHTML = `We know everything about projects related to the tokenization of business, 
        and we go through the entire life cycle of the project with you, starting from the creation of the tokenomics model to 
        successful launch and subsequent live monitoring & control.`;
      }
      if (i >= 4) {
        i = 0;
        document.getElementById('slideTitile').innerHTML = 'CRYPTOCURRENCY PROJECT SUPPORT SYSTEM';
        document.getElementById('slideBody').innerHTML = `Formal Verification and Analysis Service for the Blockchain
          Solutions from a team with over 20 years experience in industrial formal verification, algebraic
          modelling, cybersecurity, model-based testing and blockchain projects development.`;
      }
      i++;
    }, 6000);

  }
  /**
   * Window scroll method
   */
  // tslint:disable-next-line: typedef
  windowScroll() {
    const navbar = document.getElementById('navbar');
    if (document.body.scrollTop > 40 || document.documentElement.scrollTop > 40) {
      navbar.style.backgroundColor = '#272a33';
      navbar.style.padding = '10px';
    }
    else {
      navbar.style.backgroundColor = '';
      navbar.style.padding = '20px';
    }
  }

  /**
   * Section changed method
   * @param sectionId specify the current sectionID
   */
  onSectionChange(sectionId: string) {
    this.currentSection = sectionId;
  }

  /**
   * Toggle navbar
   */
  toggleMenu() {
    document.getElementById('navbarCollapse').classList.toggle('show');
  }

  /**
   * Open modal
   * @param content content
   */
  openModal(content) {
    this.modalService.open(content, { windowClass: 'dark-modal', size: 'lg' });
  }
  onStateChange(event) {
    this.ytEvent = event.data;
  }
  savePlayer(player) {
    this.player = player;
  }
  playVideo() {
    this.player.playVideo();
  }
  pauseVideo() {
    this.player.pauseVideo();
  }
}
